import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePageTitle } from "@/context/ShopContext";

const SECTIONS = [
  {
    id: "shipping",
    title: "Shipping",
    body: "Orders are lovingly prepared and dispatched within 2–3 business days across India. Complimentary shipping is offered on all orders above ₹1,999; a flat fee of ₹99 applies below that. Delivery typically takes 3–7 business days depending on your location.",
  },
  {
    id: "returns",
    title: "Returns",
    body: "If a piece is not quite right, you may return it within 14 days of delivery, unworn and with tags attached. Write to us through the contact page and we will guide you through the process with care.",
  },
  {
    id: "privacy",
    title: "Privacy Policy",
    body: "Your details are used only to fulfil your order and to respond to your messages. We never sell or share your personal information with third parties for marketing. This site stores your bag and wishlist locally on your own device.",
  },
  {
    id: "terms",
    title: "Terms & Conditions",
    body: "All content, imagery and the LAMSAH / لمسة wordmark belong to LAMSAH. Prices are listed in Indian Rupees and may change without notice. While this boutique is in its preview stage, checkout operates in a demo mode and no payment is collected.",
  },
];

export default function CustomerCare() {
  usePageTitle("Customer Care");
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    }
  }, [hash]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 md:py-24" data-testid="customer-care-page">
      <p className="overline-label mb-4">Customer Care</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tight">How We Care for You</h1>
      <div className="mt-14 space-y-14">
        {SECTIONS.map((s) => (
          <section key={s.id} id={s.id} className="scroll-mt-28" data-testid={`care-${s.id}`}>
            <h2 className="font-serif text-2xl">{s.title}</h2>
            <p className="text-sm sm:text-base text-espresso/70 leading-relaxed mt-4">{s.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
